export const getHost = () => "https://testapi.holiserver.com/";



export const dateToInputString = (dat) => {
    if (!dat) return "";
    return dat.getFullYear() + "-" + (dat.getMonth() + 1 < 10 ? "0" : "") + (dat.getMonth() + 1) + "-" + (dat.getDate() < 10 ? "0" : "") + dat.getDate()
}